import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/WFOTPaymentSuccess.css";

const WFOTPaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(10);

  const { 
    wfotData, 
    paymentDetails
  } = location.state || {};

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/wfot');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  if (!wfotData || !paymentDetails) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <h3>Invalid Access</h3>
          <p>Please complete the payment process first.</p>
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/wfot-form')}
          >
            Go to WFOT Form
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <section
        className="hero-fixed-wfot-success"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-content-wfot-success">
          <h1 className="hero-title">
            All India Occupational Therapists' Association
          </h1>
        </div>
      </section>

      <div className="scrollable-content scrollable-content-wfot-success">
        <div className="content-container wfot-success-content-container">
          <section className="wfot-success-section">
            <Container className="mt-5">
              <h2 className="text-center wfot-success-heading mb-4 pt-4">
                Application Submitted Successfully!
              </h2>

              <Row className="justify-content-center">
                <Col md={8}>
                  <Card className="p-4 shadow-sm success-card">
                    <div className="text-center">
                      <div className="success-icon mb-4">
                        <i className="fas fa-check-circle" style={{ fontSize: '64px', color: '#28a745' }}></i>
                      </div>
                      
                      <h3 className="mb-3 text-success">Thank You!</h3>
                      
                      <p className="mb-4 lead">
                        Your WFOT Individual Membership application has been submitted successfully.
                      </p>

                      <div className="application-details mb-4">
                        <h5 className="mb-3">Application Details</h5>
                        <div className="details-grid">
                          <div className="detail-item">
                            <span className="label">Name:</span>
                            <span className="value">{wfotData.name}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Email:</span>
                            <span className="value">{wfotData.email}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Phone:</span>
                            <span className="value">{wfotData.phone}</span>
                          </div>
                          <div className="detail-item">
                            <span className="label">Place of Work:</span>
                            <span className="value">{wfotData.place_of_work}</span>
                          </div>
                        </div>
                      </div>

                      {paymentDetails && (
                        <div className="payment-details mb-4">
                          <h5 className="mb-3">Payment Details</h5>
                          <div className="details-grid">
                            <div className="detail-item">
                              <span className="label">Order ID:</span>
                              <span className="value">{paymentDetails.orderId}</span>
                            </div>
                            <div className="detail-item">
                              <span className="label">Payment ID:</span>
                              <span className="value">{paymentDetails.paymentId}</span>
                            </div>
                            <div className="detail-item">
                              <span className="label">Amount Paid:</span>
                              <span className="value">₹{paymentDetails.amountInRupees?.toFixed(2) || (paymentDetails.amount/100).toFixed(2)}</span>
                            </div>
                          </div>
                        </div>
                      )}

                      <Alert variant="success" className="mb-4">
                        <h6 className="mb-3">
                          <i className="fas fa-info-circle me-2"></i>
                          What happens next?
                        </h6>
                        <ul className="mb-0 text-start">
                          <li>Your application has been successfully submitted</li>
                          <li>Payment has been verified and processed</li>
                          <li>Your application is now pending secretary approval</li>
                          <li>Once approved, your WFOT certificate will be issued</li>
                          <li>You will receive email notifications about the status updates</li>
                          <li>The certificate will be valid for 1 year from the approval date</li>
                        </ul>
                      </Alert>

                      <Alert variant="info" className="mb-4">
                        <h6 className="mb-2">
                          <i className="fas fa-clock me-2"></i>
                          Processing Time
                        </h6>
                        <p className="mb-0">
                          Please allow 3-4 weeks for the secretary to review and approve your application. 
                          You will be notified via email once the approval is complete.
                        </p>
                      </Alert>

                      <Alert variant="warning" className="mb-4">
                        <h6 className="mb-2">
                          <i className="fas fa-envelope me-2"></i>
                          Important Note
                        </h6>
                        <p className="mb-0">
                          Please check your email regularly for updates regarding your application status. 
                          If you don't receive any communication within 4 weeks, please contact us.
                        </p>
                      </Alert>

                      <Alert variant="secondary">
                        <p className="mb-0">
                          <i className="fas fa-arrow-left me-2"></i>
                          Redirecting to WFOT page in {countdown} seconds...
                        </p>
                      </Alert>

                      <div className="mt-4">
                        <button 
                          className="btn btn-primary me-3"
                          onClick={() => navigate('/wfot')}
                        >
                          Go to WFOT Page
                        </button>
                        <button 
                          className="btn btn-outline-secondary"
                          onClick={() => navigate('/')}
                        >
                          Go to Home
                        </button>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default WFOTPaymentSuccess;
